<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title">
            收货地址<span><el-button size="mini" type="danger" @click="newAddress()">新增</el-button></span>
        </div>
        <div class="user_content_blcok_line"></div>
        <div class="user_content_block_show">
            <div class="user_address_list">
                <ul>
                    <li v-for="(v,k) in address_list" :key="k">
                        <dl>
                            <dt><img width="32px" height="32px" src="@/static/img/public/address_pos.jpg" alt=""></dt>
                            <dd>{{v.name}}</dd>
                            <dd class="address_info">{{v.province+' '+v.city+' '+v.county+' '+v.addressDetail}} {{v.tel}}</dd>
                        </dl>
                        <div class="address_handle">
                            <span class="red" v-show="v.isDefault"><i class="icon iconfont">&#xeb96;</i>默认地址</span>
<!--                            <span v-show="v.isDefault==false" @click="set_default(v.id)">设置默认</span><span class="red" v-show="v.isDefault"><i class="icon iconfont">&#xeb96;</i>默认地址</span>|-->
                            <span @click="get_address_info(v)" style="cursor:pointer">编辑</span><span style="padding-bottom:2px">|</span><span @click="del(v)" style="cursor:pointer">删除</span></div>
                        <div class="clear"></div>
                    </li>
                </ul>
            </div>
            <div class="home_fy_block" style="margin-top:40px;" v-if="address_list.length>0">
                <el-pagination @current-change="current_change" background layout="total, prev, pager, next, jumper" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible" :append-to-body="true" ref="info" :title="edit_id>0?'编辑收货地址':'新增收货地址'" @close="close_dialog">
            <div class="home_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="收货人" prop="name" :rules="[{required:true,message:'收货人不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.name"></el-input></el-form-item>
                    <el-form-item label="手机" prop="tel" :rules="[{required:true,message:'手机不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.tel"></el-input></el-form-item>
                    <el-form-item label="地址" prop="areaCode" :rules="[{required:true,message:'地址不能为空',trigger: 'blur' }]">
                        <el-cascader v-model="info.areaCode"  :options="area_list"></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="addressDetail" :rules="[{required:true,message:'详细地址不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.addressDetail"></el-input></el-form-item>
                    <el-form-item label="默认收货地址" prop="default" >
                        <el-switch v-model="info.isDefault" active-color="#ca151e"></el-switch>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="danger" @click="submitForm('info')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {regionData,CodeToText} from 'element-china-area-data'
import { _local } from "@/plugins/local-storage.js"
export default {
    components: {},
    props: {},
    data() {
      return {
          dialogVisible:false,
          edit_id:0,
          info:{},
          area_list:regionData,
          area_info:[],
          address_list:[],
          total_data:0, // 总条数
          page_size:10,
          current_page:1,
          // 省市区动态加载
          props:{
              value:'id',
              label:'name',
          },
      };
    },
    watch: {},
    computed: {},
    methods: {
        submitForm(formName){
            const _this = this;
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.info.province = CodeToText[_this.info.areaCode[0]];
                    _this.info.city = CodeToText[_this.info.areaCode[1]];
                    _this.info.county = CodeToText[_this.info.areaCode[2]];
                    _this.info.areaCode = _this.info.areaCode[2];
                    if(_this.info.isDefault){
                        _this.info.isDefault = 1;
                    }else{
                        _this.info.isDefault = 0
                    }

                    if(_this.edit_id>0){
                        _this.info.id=_this.edit_id
                        _this.$post(_this.$api.editAddress,_this.info).then(function(res){
                            if(res.code == 0){
                                _this.$message.success("编辑成功");
                                _this.dialogVisible = false;
                                _this.get_address_list();
                            }else{
                                _this.$message.error(res.msg);
                            }
                        });
                    }else{
                        _this.info.id=''
                        _this.$post(_this.$api.addressSave,_this.info).then(function(res){
                            if(res.code == 0){
                                _this.$message.success("新增成功");
                                _this.dialogVisible = false;
                                _this.get_address_list();
                            }else{
                                _this.$message.error(res.msg);
                            }
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        get_area_list:function(){
            // this.$get(this.$api.homeGetAreaList,{}).then(res=>{
            //     this.area_list = res.data;
            // });
        },
        current_change:function(e){
            this.current_page = e;
            this.get_address_list();
        },
        get_address_list:function(){
            const userId=JSON.parse(_local.get('user_info')).id;
            this.$get(this.$api.getAddressList,{userId:userId,name:'',page:this.current_page,limit:this.page_size}).then(res=>{
                this.address_list = res.list;
                this.total_data = res.totalrecords;
            });
        },
        newAddress(){
            this.edit_id = 0;
            this.info = {};
            this.dialogVisible = true;
        },
        get_address_info(vo){
            this.edit_id = vo.id;
            this.dialogVisible = true;
            this.info = vo;
            this.info.isDefault = this.info.isDefault?true:false
            this.info.areaCode = [vo.areaCode.substr(0,2)+'0000',vo.areaCode.substr(0,4)+"00",vo.areaCode];
            // this.$get(this.$api.editAddress+id).then(res=>{
            //     this.info = res.data;
            //     this.default = res.data.is_default==0?false:true;
            // });
        },
        set_default:function(id){
            this.$post(this.$api.setDefaultAddress,{id:id}).then(()=>{
                this.get_address_list();
                return this.$message.success('设置默认地址成功');
            });
        },
        // 删除处理
        del(obj){
            let _this = this;
            this.$post(this.$api.delAddress,obj).then(function(res){
                if(res.code === 0){
                    _this.get_address_list();
                    return _this.$message.success("删除成功");
                }else{
                    return _this.$message.error(res.msg);
                }
            });
        },
        close_dialog:function(){
            this.edit_id = 0;
        }
    },
    created() {
        this.get_address_list();
        this.get_area_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
/deep/ .more{
    float: none;
}
/deep/ .el-pagination__jump{
    margin-left: 10px;
}
.user_address_list{
    padding-top: 10px;
    ul li{
        margin-bottom: 5px;
        padding-bottom: 5px;
        border-bottom: 1px solid #efefef;
        dl{
            float: left;
            display: block;
            width: 650px;
            dt{
                float: left;
                margin-right: 10px;
                img{
                    border-radius: 50%;
                    margin-top: 3px;
                }
            }
            dd{
                line-height: 20px;
                width: 190px;
                width: 500px;
                float: left;
            }
            dd.address_info{
                color:#999;
                float: left;
                width:100%;
                width: 500px;
            }
        }
        .address_handle{
            color:#666;
            line-height: 20px;
            display:flex;
            justify-content: flex-end;
            align-items: center;
            span{
                display:block;
                margin: 0 5px; 
                i{
                    margin-right: 5px;
                }
                
            }
            span:hover{
                color:#ca151e;
            }
            span.red{
                color:#ca151e;
            }
        }
    }
}
.user_content_blcok_title{
    padding-left: 10px;
}
.user_content_blcok{
    min-height: 365px;
}
.home_fy_block{
    text-align: right;
    margin-top: 20px !important;
}
.user_content_blcok_line{
    margin: 15px 0 10px;
}
</style>